import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { updateNationalCode } from 'services/auth_national'

export default function useAddNationalCode(refetch: () => void) {
    const { mutate } = useMutation({
        mutationFn: (nationalCode: string) => {
            return updateNationalCode(nationalCode)
        },
        onSuccess: () => {
            toast.success('کد ملی با موفقیت تایید شد')
            refetch()
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutate }
}
